import { PrimeIcons } from "primereact/api";

const {
  ARROW_UP_RIGHT_AND_ARROW_DOWN_LEFT_FROM_CENTER: expandIcon,
} = PrimeIcons;

const initialState = {
  icon: expandIcon,
  isFullScreen: false,
};

export const getInitialState = () => structuredClone(initialState);

export default initialState;
